module.exports = "/_next/static/pages/test-guidelines/183aac106c26762d4c144d681a16268c.png";